import React from 'react';
import { connect, useSelector } from 'react-redux';
import Translate from './components/Translate';
import { translate } from './util';
var mapStateToProps = function mapStateToProps(_ref) {
  var application = _ref.application;
  return {
    siteLanguage: application.siteLanguage,
    translations: application.translations
  };
};
export var T = connect(mapStateToProps)(Translate);
T.md = function (_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    headingRenderer = _ref2.headingRenderer,
    includeNodeIndex = _ref2.includeNodeIndex,
    inline = _ref2.inline,
    linkRenderer = _ref2.linkRenderer,
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? {} : _ref2$params,
    source = _ref2.source,
    translations = _ref2.translations,
    useLink = _ref2.useLink;
  return /*#__PURE__*/React.createElement(T, {
    className: className,
    headingRenderer: headingRenderer,
    includeNodeIndex: includeNodeIndex,
    inline: inline,
    linkRenderer: linkRenderer,
    markdownify: true,
    params: params,
    source: source,
    translations: translations,
    useLink: useLink
  });
};
export var useTranslate = function useTranslate() {
  var translations = useSelector(function (_ref3) {
    var application = _ref3.application;
    return application.translations;
  });
  var t = function t(term) {
    var substitutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return translate(term, substitutes, translations);
  };
  var translationExists = function translationExists(source) {
    var translatedSource = translate(source, {}, translations);
    return source !== translatedSource && translatedSource.trim().length > 0;
  };
  return {
    t: t,
    translationExists: translationExists
  };
};
var _translationsForContextAndLanguage = function translationsForContextAndLanguage(context, language) {
  var retriesLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
  var languageToLocaleMap = {
    br: 'pt_BR',
    cn: 'zh_CN',
    en: 'en_US',
    es: 'es_ES',
    jp: 'ja_JP'
  };
  var locale = languageToLocaleMap[language] || languageToLocaleMap.en;
  return new Promise(function (resolve, reject) {
    import(/* webpackChunkName: "[request]" */"translations/client.".concat(context, ".").concat(locale, ".json")).then(function (d) {
      return resolve(d.default);
    }).catch(function (e) {
      setTimeout(function () {
        if (retriesLeft === 1) {
          reject(e);
          return;
        }
        _translationsForContextAndLanguage(context, language, retriesLeft - 1, interval).then(resolve, reject);
      }, interval);
    });
  });
};
export { _translationsForContextAndLanguage as translationsForContextAndLanguage };